export default "__VITE_ASSET__CiK3sew$__"